<style lang="sass">
@import ~nespresso-bi/utilities
@import ~nespresso-bi/foundation/foundation
@import ~nespresso-bi/brand/brand
@import ~nespresso-components/swiper/swiper
@import ~nespresso-bi/brand/variables
@import sass/variables
@import sass/main
</style>

<template>
    <div
        class="g"
        v-if="$json">
        <Hero
            v-if="!$json.hero.hide"
            id="hero"
            :backgroundImage="{ folder:'hero', name: $json.hero.background }"
            trackingVideoLabel="Nespresso Momento">
            <template slot="before">
                <Heading
                    :level="1"
                    v-html="$json.hero.title"/>
                <Paragraph
                    :content="$json.hero.copy"
                    :size="$breakpoint.isS ? 'L': 'XL'"
                    class="g_hero__copy"/>
            </template>
        </Hero>
        <Zone
            v-if="!$json.moreMachines.hide"
            id="moreMachines"
            contrast="light"
            class="g_moreMachines g_section_bg_inside"
            align="center"
            autoHeight>
            <BgTable v-if="!$breakpoint.isS" :backgroundImage="{ folder: 'moreMachines', name: $json.moreMachines.background }"/>
            <Heading
                :level="2"
                v-html="$json.moreMachines.catchLine"/>
            <Paragraph
                :content="$json.moreMachines.copy"
                :size="$breakpoint.isS ? 'L': 'XL'"
                class="g_moreMachines__copy"/>
            <Grid
                type="div"
                row="1">
                <div class="g_row" :class="{ 'g_nomilk': !$json.moreMachines.machine1.machineImg }">
                    <div class="g_col3 g_machine g_machine1" v-if="$json.moreMachines.machine1.machineImg">
                        <Visual class="image" :src="{ folder: 'moreMachines/machines', name: $json.moreMachines.machine1.machineImg, ext: 'png' }"/>
                        <Heading
                            :level="3"
                            v-html="$json.moreMachines.machine1.head"/>
                        <Paragraph
                            class="g_copy"
                            :content="$json.moreMachines.machine1.copy"
                            :size="$breakpoint.isS ? 'L': 'L'"/>
                    </div>
                    <div class="g_col3 g_machine g_machine2" v-if="$json.moreMachines.machine2.machineImg">
                        <Visual class="image" :src="{ folder: 'moreMachines/machines', name: $json.moreMachines.machine2.machineImg, ext: 'png' }"/>
                        <Heading
                            :level="3"
                            v-html="$json.moreMachines.machine2.head"/>
                        <Paragraph
                            class="g_copy"
                            :content="$json.moreMachines.machine2.copy"
                            :size="$breakpoint.isS ? 'L': 'L'"/>
                    </div>
                    <div class="g_col3 g_machine g_machine3" v-if="$json.moreMachines.machine3.machineImg">
                        <Visual class="image" :src="{ folder: 'moreMachines/machines', name: $json.moreMachines.machine3.machineImg, ext: 'png' }"/>
                        <Heading
                            :level="3"
                            v-html="$json.moreMachines.machine3.head"/>
                        <Paragraph
                            class="g_copy"
                            :content="$json.moreMachines.machine3.copy"
                            :size="$breakpoint.isS ? 'L': 'L'"/>
                    </div>
                </div>
            </Grid>
        </Zone>
        <MachineSlider v-if="$json.machineSlider && !$json.machineSlider.hide"/>
        <Zone
            v-if="$json.paymentOptions && !$json.paymentOptions.hide"
            id="paymentOptions"
            align="center"
            contrast="dark"
            class="g_paymentOptions">
            <Heading
                :level="$breakpoint.isS ? 3: 2"
                v-html="$json.paymentOptions.title"/>
            <Paragraph
                :content="$json.paymentOptions.description"
                :size="$breakpoint.isS ? 'L': 'XL'"
                class="g_description"/>
            <Grid
                type="div"
                row="1">
                <div class="g_row">
                    <div class="g_col3 g_machine g_machine1" v-if="$json.paymentOptions.option1.machineImg">
                        <Visual class="image" :src="{ folder: 'paymentOptions', name: $json.paymentOptions.option1.machineImg, ext: 'png' }"/>
                        <Heading
                            :level="3"
                            v-html="$json.paymentOptions.option1.head"/>
                        <Paragraph
                            class="g_copy"
                            :content="$json.paymentOptions.option1.copy"
                            :size="$breakpoint.isS ? 'L': 'L'"/>
                    </div>
                    <div class="g_col3 g_machine g_machine2" v-if="$json.paymentOptions.option2.machineImg">
                        <Visual class="image" :src="{ folder: 'paymentOptions', name: $json.paymentOptions.option2.machineImg, ext: 'png' }"/>
                        <Heading
                            :level="3"
                            v-html="$json.paymentOptions.option2.head"/>
                        <Paragraph
                            class="g_copy"
                            :content="$json.paymentOptions.option2.copy"
                            :size="$breakpoint.isS ? 'L': 'L'"/>
                    </div>
                    <div class="g_col3 g_machine g_machine3" v-if="$json.paymentOptions.option3.machineImg">
                        <Visual class="image" :src="{ folder: 'paymentOptions', name: $json.paymentOptions.option3.machineImg, ext: 'png' }"/>
                        <Heading
                            :level="3"
                            v-html="$json.paymentOptions.option3.head"/>
                        <Paragraph
                            class="g_copy"
                            :content="$json.paymentOptions.option3.copy"
                            :size="$breakpoint.isS ? 'L': 'L'"/>
                    </div>
                </div>
            </Grid>
            <Paragraph
                class="g_choose"
                :content="$json.paymentOptions.choose"
                :size="$breakpoint.isS ? 'L': 'L'"/>
            <Cta
                type="text"
                :content="$json.paymentOptions.ctaText+' ' "
                :link="$json.paymentOptions.ctaLink"
                @click="tracking('freeTrial','Click CTA - Contact Us')"
                class="g_btnGold"
                isBtn />
            <Paragraph
                class="g_disclaimer"
                :content="$json.paymentOptions.disclaimer"
                :size="$breakpoint.isS ? 'L': 'S'"/>
        </Zone>
        <Zone
            v-if="$json.maintenanceAlternatives && !$json.maintenanceAlternatives.hide"
            id="maintenanceAlternatives"
            align="center"
            contrast="light"
            class="g_maintenanceAlternatives">
            <Heading
                :level="$breakpoint.isS ? 3: 2"
                v-html="$json.maintenanceAlternatives.title"/>
            <Paragraph
                :content="$json.maintenanceAlternatives.description"
                :size="$breakpoint.isS ? 'L': 'XL'"
                class="g_description"/>
            <Grid
                type="div"
                row="1">
                <div class="g_row">
                    <div class="g_col3 g_machine g_machine1" v-if="$json.maintenanceAlternatives.option1.machineImg">
                        <Visual class="image" :src="{ folder: 'maintenanceAlternatives', name: $json.maintenanceAlternatives.option1.machineImg, ext: 'png' }"/>
                        <Heading
                            :level="3"
                            v-html="$json.maintenanceAlternatives.option1.head"/>
                        <Paragraph
                            class="g_copy"
                            :content="$json.maintenanceAlternatives.option1.copy"
                            :size="$breakpoint.isS ? 'L': 'L'"/>
                    </div>
                    <div class="g_col3 g_machine g_machine2" v-if="$json.maintenanceAlternatives.option2.machineImg">
                        <Visual class="image" :src="{ folder: 'maintenanceAlternatives', name: $json.maintenanceAlternatives.option2.machineImg, ext: 'png' }"/>
                        <Heading
                            :level="3"
                            v-html="$json.maintenanceAlternatives.option2.head"/>
                        <Paragraph
                            class="g_copy"
                            :content="$json.maintenanceAlternatives.option2.copy"
                            :size="$breakpoint.isS ? 'L': 'L'"/>
                    </div>
                    <div class="g_col3 g_machine g_machine3" v-if="$json.maintenanceAlternatives.option3.machineImg">
                        <Visual class="image" :src="{ folder: 'maintenanceAlternatives', name: $json.maintenanceAlternatives.option3.machineImg, ext: 'png' }"/>
                        <Heading
                            :level="3"
                            v-html="$json.maintenanceAlternatives.option3.head"/>
                        <Paragraph
                            class="g_copy"
                            :content="$json.maintenanceAlternatives.option3.copy"
                            :size="$breakpoint.isS ? 'L': 'L'"/>
                    </div>
                </div>
            </Grid>
            <Cta
                type="text"
                :content="$json.maintenanceAlternatives.ctaText+' ' "
                :link="$json.maintenanceAlternatives.ctaLink"
                @click="tracking('freeTrial','Click CTA - Contact Us')"
                class="g_btnGold"
                isBtn />
        </Zone>
        <Compare />
        <Zone
            v-if="!$json.moreInfo.hide"
            :backgroundImage="{ folder: 'moreInfo', name: $json.moreInfo.background }"
            id="moreInfo"
            align="center"
            autoHeight
            contrast="dark"
            class="g_moreInfo">
            <Heading
                :level="2"
                v-html="$json.moreInfo.title" />
            <Paragraph
                :content="$json.moreInfo.content"
                size="XL"
                sizeMobile="L" />
            <Cta
                v-if="$json.moreInfo.ctaLink"
                :content="$json.moreInfo.ctaText"
                :link="$json.moreInfo.ctaLink"
                isGold
                @click="tracking('freeTrial','Click CTA - Contact Us')"
                type="text" />
        </Zone>
    </div>
</template>

<script>
import Hero from 'gvue/src/components/Hero'
import Visual from 'gvue/src/core/Visual'
import BgTable from '../../components/BgTable'
import { Grid } from 'gvue/src/core/Grid'

import tracking from '../../assets/js/mixins/tracking'
import Compare from '../../components/CompareBlock/Compare'

import MachineSlider from '../../components/MachineSlider/MachineSlider'

export default {
    name: 'App',
    mixins: [tracking],
    components: {
        Hero,
        Visual,
        BgTable,
        Grid,
        MachineSlider,
        Compare
    },
    computed: {
    }
}
</script>
